import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";

import { api } from "~/data/core/api";

import { Field } from "../shared/field";
import { cn } from "../shared/utils/cn";
import { Button } from "../shared/button";

interface Props {
  userTestId: string;
  onFinish: () => void;
}

export function FeedbackForm({ userTestId, onFinish }: Props) {
  const form = useForm({ defaultValues: { comment: "" } });
  const mutation = useMutation({
    mutationFn: async (comment: string) => {
      await api.post("/api/v1/feedbacks", {
        feedback: { user_test_id: userTestId, comment },
      });
    },
  });
  return (
    <form
      onSubmit={form.handleSubmit(async (data) => {
        await mutation.mutateAsync(data.comment);
        toast.success("Feedback enviado!");
        onFinish();
      })}
    >
      <h3 className="text-sm leading-4 uppercase font-semibold font-alternative mb-5">
        Feedback
      </h3>
      <Field label="Comentário" className="mb-6">
        <textarea
          {...form.register("comment")}
          className={cn(
            "bg-[#E8E8E8] w-full px-3 py-3 rounded-lg placeholder:text-[#979797] border-b border-b-primary-1 text-sm"
          )}
          rows={5}
        />
      </Field>

      <Button
        variant="primary-1"
        className="w-60 h-10 ml-auto"
        loading={mutation.isPending}
        disabled={!form.watch("comment")}
      >
        Enviar
      </Button>
    </form>
  );
}
